<template>
 <header>
  <div id="header_downside" v-if="showDownside">
    <!-- お問い合わせ -->
    <dd-support-modal
      ref="supportModalRef"
      @closeContact="closeContact"
    />
    <ul class="hddw_nav">
    <li>
      <span v-if="!dispTrialUserTools"><img :src="getImage('component/common/header/daros_logo_white.svg')" width="120px" height="auto"/></span>
      <span v-if="dispTrialUserTools"><img :src="getImage('component/common/header/daro_try_logo.svg')" width="210px" height="auto"/></span>
    </li>
    <li id="home_ico">
      <router-link to="/" v-if="!dispTrialUserTools">
        <img :src="getImage('component/common/header/ic_top.svg')" alt="home" />
        <span>TOP</span>
      </router-link>
    </li>
     <li class="contact" v-if="dispTrialUserTools">
       <a href="#" @click.prevent="showContact">
         <span>お問い合わせ/お打合わせ依頼</span>
       </a>
     </li>
    <li class="account">
     <a @click="onClickCorpConfig">
       <img :src="getImage('pages/planning/ic_corp.svg')" alt="company"/>
       <span>{{ userInfo.corpName }}</span>
       <img class="arrow" :src="getImage('component/common/header/ic_arrow_right.svg')" alt="user"/>
     </a>
    </li>
    <li class="account" v-if="!dispTrialUserTools">
     <a href="#" @click.prevent>
       <img :src="getImage('pages/planning/ic_user.svg')" alt="user"/>
       <span>{{ userInfo.userName }}</span>
       <img class="arrow" :src="getImage('component/common/header/ic_arrow_right.svg')" alt="user"/>
     </a>
    </li>
    <li class="logout">
      <a href="#" @click.prevent="logout">
        <img :src="getImage('component/common/header/ic_logout.svg')"/>
        <span>Logout</span>
      </a>
    </li>
    <li class="header_downside_toggle">
      <span v-if="!isDispMenu">
        <img :src="getImage('pages/planning/ic_plus_off.svg')" alt="toggle" width="24px" height="auto"  @click="$emit('onClickMenuToggle', true)">
      </span>
    </li>
    <li class="header_downside_toggle">
      <span v-if="!isDispContent">
        <img :src="getImage('pages/planning/ic_plus_on.svg')" alt="toggle" width="24px" height="auto"  @click="$emit('onClickContentToggle', true)">
      </span>
    </li>
   </ul>
  </div>
 </header>
</template>
<script>
import axios from 'axios'
import {API_URL, STORAGE_KEY} from '../../constants/App'
import {USER_TYPE, LICENSE_TYPE} from '../../constants/Type'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import SupportModal from '../../components/common/SupportModal'

export default {
  name: 'Header',
  components: {
    'dd-support-modal': SupportModal
  },
  props: {
    showUpside: {
      type: Boolean,
      default: true
    },
    showDownside: {
      type: Boolean,
      default: true
    },
    isDispMenu: {
      type: Boolean,
      default: true
    },
    isDispContent: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    userInfo: function () {
      return App.getUserInfo()
    },
    dispTrialUserTools: function () {
      let user = App.getUserInfo()
      return user && LICENSE_TYPE.TRIAL === user.licenseType
    }
  },
  methods: {
    // ログアウト
    logout: function (event) {
      axios.post(API_URL.LOGOUT, {}
      ).then(response => {
        App.removeLocalStorage(STORAGE_KEY.USER_INFO)
        this.$router.push({
          name: 'DcLogin'
        })
      }).catch(error => {
        Api.handleError(error)
      })
    },
    // 企業メニューを表示
    onClickCorpConfig: function () {
      this.addEventListener()
      const user = App.getLocalStorage(STORAGE_KEY.USER_INFO)
      if (user.userType === USER_TYPE.DOMANS_ADMIN.code || user.userType === USER_TYPE.ADMIN.code) {
        let modalData = {
          onCancel: () => {
            this.closeContact()
          },
          routeOrderList: () => { this.$router.push({name: 'Order'}) }
        }
        App.showCorpConfigModal(modalData)
      }
    },
    // お問い合わせモーダルを表示
    showContact: function () {
      this.addEventListener()
      this.$refs.supportModalRef.showModal()
    },
    // キャンバスのイベントリスナを有効化
    closeContact: function () {
      this.$emit('onCloseModal')
      document.removeEventListener('keydown', this.onKeydown)
    },
    // キャンバスのイベントリスナを無効化
    addEventListener: function () {
      this.$emit('onShowModal')
      document.addEventListener('keydown', this.onKeydown)
    },
    getImage: function (image) {
      return App.getDarosResource(image)
    }
  }
}
</script>
<style src="../../css/planning/planning.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.hddw_nav li:first-child {
  font-weight: bold;
  padding-left: 47px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/common/Header.vue